export const upperCaseLetterValidatorRegExp = /[A-Z]/;
export const upperCaseLettersValidatorRegExp = /^[A-Z]+$/;

export const validateUpperCaseLetter = (
  string: string,
): boolean => upperCaseLetterValidatorRegExp.test(string);
export const validateUpperCaseLetters = (
  string: string,
): boolean => upperCaseLettersValidatorRegExp.test(string);
